<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isPurchaseManager()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Manage Inventory | Purchase Manager</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-outline card-danger collapsed-card">
                        <div class="card-header">
                            <h5 class="card-title">Data Filters</h5>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                            <!-- /.card-tools -->
                        </div>
                        <div class="card-body overflow-auto">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Branch:</span
                                            >
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branches"
                                                :reduce="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Item Detail:</span
                                            >
                                            <input
                                                type="text"
                                                v-model="item_detail"
                                                placeholder="Enter item any item detail"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Assigned:</span
                                            >
                                            <select
                                                type="text"
                                                v-model="assigned"
                                                class="form-control"
                                            >
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >From Date:</span
                                            >
                                            <input
                                                type="date"
                                                v-model="from"
                                                placeholder="Select from date"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >To Date:</span
                                            >
                                            <input
                                                type="date"
                                                v-model="to"
                                                placeholder="Select to date"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100%"
                                            @click="
                                                getInventory(
                                                    '/api/getInventory'
                                                )
                                            "
                                        >
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                    <div class="col-sm-4">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100%"
                                            @click="reset"
                                        >
                                            <i class="fa fa-times"></i> Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-danger card-outline">
                        <div class="card-header">Manage Inventory</div>
                        <div class="card-body overflow-auto">
                            <img v-if="inventory == ''" src="" />
                            <datatable
                                style="margin-top: 1%"
                                :columns="columns"
                                v-else
                            >
                                <tbody>
                                    <tr v-for="b in inventory" :key="b.id">
                                        <td>{{ b.item_name }}</td>
                                        <td>{{ b.imei_no }}</td>
                                        <td>{{ b.item_code }}</td>
                                        <td>{{ b.branch }}</td>
                                        <td>{{ b.created_at | addedDate }}</td>
                                        <td>
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <button
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        class="btn btn-danger"
                                                        @click="view(b.id)"
                                                    >
                                                        <i
                                                            class="fa fa-edit"
                                                        ></i>
                                                        Edit Item Details
                                                    </button>
                                                </div>
                                                <br />
                                                <div class="row">
                                                    <a
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        class="btn btn-secondary"
                                                        v-if="
                                                            b.assigned_to !=
                                                            null
                                                        "
                                                        :href="
                                                            '/purchase-manager/job-profile/' +
                                                            b.assigned_to
                                                        "
                                                        ><i
                                                            class="fa fa-eye"
                                                        ></i>
                                                        Assigned to Job</a
                                                    >
                                                </div>
                                                <br />
                                                <div class="row">
                                                    <button
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        class="btn btn-danger"
                                                        v-if="
                                                            b.assigned_to ==
                                                            null
                                                        "
                                                        @click="
                                                            deleteItem(b.id)
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-trash"
                                                        ></i>
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </datatable>

                            <!-- content here -->
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getInventory(pagination.prevPageUrl)"
                                @next="getInventory(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isPurchaseManager()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getInventory();
        this.getBranches();
    },

    components: { datatable: Datatable, pagination: Pagination },

    data() {
        let columns = [
            { width: "20%", label: "Name", name: "item_name" },
            { width: "15%", label: "IMEI/SERIAL", name: "imei_no" },
            { width: "15%", label: "Code", name: "item_code" },
            { width: "10%", label: "Branch", name: "branch" },
            { width: "20%", label: "Added on", name: "created_at" },
            { width: "20%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            inventory: [],
            branches: [],
            branch: "",
            item_detail: "",
            from: "",
            to: "",
            assigned: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branch = response.data;
            });
        },

        getInventory(url = "/api/getInventory") {
            axios
                .post(url, {
                    branch: this.branch,
                    item_detail: this.item_detail,
                    from: this.from,
                    to: this.to,
                    assigned: this.assigned,
                })
                .then((response) => {
                    this.inventory = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        view(id) {
            this.$router.push("/purchase-manager/item-data/" + id);
        },

        deleteItem(id) {
            axios
                .post("/api/deleteInventoryItem", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Removed",
                        });
                        this.getInventory();
                    } else if (response.data == 500) {
                        toast.fire({
                            icon: "error",
                            title: "Item Assigned",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        reset() {
            this.branch = "";
            this.item_detail = "";
            this.from = "";
            this.to = "";
            this.assigned = "";
            this.getInventory();
        },
    },
};
</script>
